export {
  formatQuoteAmount as formatInvoiceAmount,
  formatQuoteDate as formatInvoiceDate,
  quoteCurrencyCode as invoiceCurrencyCode,
} from "~/features/Quotes/detail/utils/format";

/** True when due date is set and still today or in the future (end of that day). */
export const isDueDateInFuture = (dueDate?: string | null) => {
  if (!dueDate) return false;
  const end = new Date(dueDate);
  if (Number.isNaN(end.getTime())) return false;
  end.setHours(23, 59, 59, 999);
  return end.getTime() >= Date.now();
};

/** True when the invoice has a past-due dueDate and isn't already settled. */
export const isInvoiceOverdue = (invoice?: {
  status?: string | null;
  dueDate?: string | null;
}) => {
  if (!invoice?.dueDate) return false;
  if (invoice.status === "PAID" || invoice.status === "CANCELLED") return false;
  const end = new Date(invoice.dueDate);
  if (Number.isNaN(end.getTime())) return false;
  end.setHours(23, 59, 59, 999);
  return end.getTime() < Date.now();
};
